import React from 'react';
import NumberFormat, {
  NumberFormatProps,
  NumberFormatValues,
} from 'react-number-format';
import styled from 'styled-components';

import { baseStyles } from './TextInput';

interface CurrencyInputProps
  extends Omit<NumberFormatProps, 'onChange' | 'customInput'> {
  onChange: (val?: number) => void;
  error?: boolean;
}

const StyledNumberFormat = styled(NumberFormat)`
  ${baseStyles}
  width: 400px;
`;

export const CurrencyInput = React.forwardRef<
  React.Ref<NumberFormat<unknown>>,
  CurrencyInputProps
>(({ onChange, ...rest }, ref) => {
  const onValueChange = (values: NumberFormatValues) => {
    onChange(values.floatValue);
  };

  return (
    <StyledNumberFormat
      prefix="$"
      thousandSeparator=","
      thousandsGroupStyle="thousand"
      onValueChange={onValueChange}
      isNumericString
      ref={ref as React.Ref<NumberFormat<unknown>>}
      {...rest}
    />
  );
});
